import { TransformNalmalType2TableColumn } from '../type';
import { COLUMN_FROM, VALUE_TYPES } from '../consts';
import moment from 'moment';
import _, { divide } from 'lodash';
import React, { useState } from 'react';
import { useDebounceEffect } from 'ahooks';
import { MobileDateTimePick } from './MobileDateTimePick';
import DatePickerMemo from './DatePicker';


export const transformAssetDateTime2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  isMobile,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformDateTime2TableColumn`);
  // console.log('入参field', _.cloneDeep(field));
  // console.log('入参targetColumn', _.cloneDeep(targetColumn));

  // field的key
  const fieldName = field?.name ?? '';

  // 获取配置
  const bizConfig = field?.bizConfig ?? {};

  // 是否仅日期
  const onlyDate = !!bizConfig?.onlyDate;

  // 是否仅时间
  const onlyTime = !!bizConfig?.onlyTime;

  // 是否仅过去值
  const onlyPastValues = !!bizConfig?.onlyPastValues;

  // 是否仅未来值
  const onlyFutureValues = !!bizConfig?.onlyFutureValues;

  // 是否默认系统日期
  const isSystem = !!bizConfig?.isSystem;

  // 是否为range
  const rangePicker = !!bizConfig?.rangePicker;

  const { isValidateDate, validateDateStart, validateDateEnd } = bizConfig;

  // 格式化
  const format = getFormat({ format: bizConfig?.format, onlyTime, onlyDate });

  // 获取valueType
  targetColumn.valueType = getDateTimeValueType({ onlyDate, onlyTime });
  targetColumn.fieldProps = (form, config) => getFieldProps({ onlyPastValues, onlyFutureValues });
  // if (isSystem && mode === 'edit') {
  //   targetColumn.formItemProps = {
  //     ...targetColumn.formItemProps,
  //   };
  // }
  // console.log(field)
  targetColumn.renderFormItem = (_a, config, form) => {
    return (
      <DatePickerMemo
        name={field.label}
        from={config?.from || COLUMN_FROM.TABLE}
        showTime={!onlyDate}
        onlyTime={onlyTime}
        isSystem={isSystem}
        config={config}
        isValidateDate={isValidateDate}
        validateDateStart={validateDateStart}
        validateDateEnd={validateDateEnd}
        rangePicker={rangePicker}
      />
    );
  };

  if (isMobile && !onlyTime) {
    targetColumn.renderFormItem = (_a, config, form) => {
      return (
        <MobileDateTimePick from={config?.from || COLUMN_FROM.TABLE} showTime={!onlyDate} onlyTime={onlyTime} isSystem={isSystem} />
      );
    };
  }

  // 如果是系统字段展示态返回当前格式化时间
  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    if (targerValue) {
      let text = moment(targerValue).format(format);
      if (text === 'Invalid date') {
        text = targerValue;
      }
      return text;
    }
    return '-';
  };

  // console.log(`onlyDate:${onlyDate}, onlyTime:${onlyTime}, fieldName:${fieldName}, isSystem:${isSystem}, format:${format}, columnFrom:${columnFrom}`);

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn));
  // console.groupEnd();

  return targetColumn;
};

// 获取valueType
const getDateTimeValueType = ({ onlyDate = false, onlyTime = false }) => {
  if (onlyDate) return VALUE_TYPES.DATE;
  if (onlyTime) return VALUE_TYPES.TIME;
  return VALUE_TYPES.DATE_TIME;
};

// 获取format格式化
const getFormat = ({ format = '', onlyTime = false, onlyDate = false }) => {
  const defaultFormat = 'YYYY-MM-DD HH:mm:ss';
  const defaultTimeFormat = 'HH:mm:ss';
  const defaultDateFormat = 'YYYY-MM-DD';
  let defaultFormatConfig = defaultFormat;
  if (onlyTime) {
    defaultFormatConfig = defaultTimeFormat;
  }
  if (onlyDate) {
    defaultFormatConfig = defaultDateFormat;
  }
  return format || defaultFormatConfig;
};

// 获取fieldProps
const getFieldProps = ({
  onlyPastValues,
  onlyFutureValues,
}: {
  onlyPastValues: boolean;
  onlyFutureValues: boolean;
}) => {
  const fieldProps: any = {
    disabledDate: (current: any) => {
      if (onlyPastValues) {
        return current && current > moment().endOf('second');
      }

      if (onlyFutureValues) {
        return current && current < moment().endOf('second');
      }
      return false;
    },
  };
  return fieldProps;
};
